import { defineWave } from '../schema';

/** BLOC E1 — LA PLONGÉE. L'anti-camping.
 *
 *  ── Ce que le Dard corrige ──
 *  Les deux blocs précédents apprennent à gérer l'espace : suivre un couloir,
 *  contourner une zone morte. Un joueur habile en tire une conclusion
 *  dangereuse — qu'il existe toujours un endroit où se poser et attendre. C'est
 *  le défaut classique du genre : le bas de l'écran devient un refuge, et le jeu
 *  se joue immobile.
 *
 *  Le Dard existe pour interdire ce refuge. Il attend, puis plonge à 720 u/s
 *  sur la position qu'il a choisie. Il ne tire rien : c'est une pression
 *  CORPORELLE, un projectile de 60 PV qu'on peut détruire. Le joueur a le choix
 *  entre l'abattre en le voyant venir et se déplacer — les deux étant des
 *  actions, là où camper n'en est pas une.
 *
 *  ── Ils arrivent par vagues courtes et espacées ──
 *  Trois par salve, à 0,5 s d'intervalle, puis un silence. Une pluie continue de
 *  Dards deviendrait un bruit de fond qu'on absorbe sans réagir ; espacés, ils
 *  restent des ÉVÉNEMENTS auxquels on répond un par un.
 *
 *  ── Les Rôdeurs tiennent le fond ──
 *  Leurs éventails statiques donnent au bloc sa géographie stable, pour que les
 *  plongées se lisent comme des ruptures. Sans une trame régulière derrière,
 *  une surprise n'a rien à interrompre. */
export default defineWave({
  id: 'e1-plongee',
  duration: 28,
  spawns: [
    { at: 0.5, enemy: 'rodeur', lane: 1, count: 1, spacing: 0 },
    { at: 0.9, enemy: 'rodeur', lane: 5, count: 1, spacing: 0 },
    // Banc : une école qui ondule. Beaucoup de corps, aucun tir — de la densité
    // sans charger l'écran de projectiles, exactement ce qui manquait.
    { at: 2.0, enemy: 'banc', lane: 2, count: 6, spacing: 0.12 },
    { at: 2.3, enemy: 'banc', lane: 4, count: 6, spacing: 0.12 },
    { at: 4.0, enemy: 'dard', lane: 3, count: 3, spacing: 0.5 },
    { at: 8.0, enemy: 'mite', lane: 2, count: 6, spacing: 0.08 },
    { at: 10.5, enemy: 'dard', lane: 1, count: 3, spacing: 0.5 },
    { at: 11.0, enemy: 'dard', lane: 5, count: 3, spacing: 0.5 },
    { at: 13.0, enemy: 'fauche', lane: 2, count: 2, spacing: 1.0 },
    { at: 13.4, enemy: 'fauche', lane: 4, count: 2, spacing: 1.0 },
    { at: 15.0, enemy: 'faucheur', lane: 3, count: 1, spacing: 0 },
    // Harceleur introduit SEUL et posé : le joueur découvre le missile guidé
    // sans autre menace à gérer, et apprend qu'il se sème par une esquive
    // tardive plutôt que par la fuite.
    { at: 17.0, enemy: 'harceleur', lane: 3, count: 1, spacing: 0 },
    { at: 18.0, enemy: 'dard', lane: 2, count: 4, spacing: 0.45 },
    { at: 18.5, enemy: 'dard', lane: 4, count: 4, spacing: 0.45 },
    // Méduse : grappe de dards lents qu'un seul écart ne déjoue pas — il faut
    // ne jamais s'arrêter. La leçon d'esquive-état du monde du mouvement.
    { at: 20.0, enemy: 'meduse', lane: 3, count: 1, spacing: 0 },
    { at: 23.0, enemy: 'rodeur', lane: 3, count: 1, spacing: 0 },
    { at: 25.0, enemy: 'mite', lane: 4, count: 8, spacing: 0.07 },
  ],
});
